// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { defaultReviver, keyedReviver, listReviver } = require('client-v2/common/state/revivers')
const { FetchStateEnum } = require('client-v2/common/utils/enums')

class SearchFormSuggestionItem extends Immutable.Record({
  complete: String(),
  names: Immutable.List(), // [ String(), ... ]
  photo: String(),
  type: String()
}) {
  // No methods
}

SearchFormSuggestionItem.reviver = keyedReviver(SearchFormSuggestionItem, {
  names: defaultReviver
})

class SearchFormRecord extends Immutable.Record({
  isVisible: Boolean(),
  value: String(),
  // Suggestion types
  googleSuggestions: Immutable.List(),
  googleSuggestionsState: FetchStateEnum.EMPTY,
  userSuggestions: Immutable.List(),
  userSuggestionsState: FetchStateEnum.EMPTY,
  supersearchSuggestions: Immutable.List(),
  supersearchSuggestionsState: FetchStateEnum.EMPTY
}) {
  // No methods
}

// Record Revivers
SearchFormRecord.suggestionsReviver = listReviver(SearchFormSuggestionItem.reviver)
SearchFormRecord.reviver = keyedReviver(SearchFormRecord, {
  // Suggestion types
  googleSuggestions: SearchFormRecord.suggestionsReviver,
  userSuggestions: SearchFormRecord.suggestionsReviver,
  supersearchSuggestions: SearchFormRecord.suggestionsReviver
})

module.exports = SearchFormRecord
